import { Actions, createNamespace } from "../../../../flux/Actions";
import { Division } from "../../../../models/Division";

const ns = createNamespace('EditCreateDivisions');
export const names = {
    SET_NAME: ns('SET_NAME'),
    SET_PARENT_DIVISION: ns('SET_PARENT_DIVISION'),
    SET_DIVISION_ITEMS: ns('SET_DIVISION_ITEMS'),
}

export class EditCreateDivisionActions extends Actions
{
    setName = (name: string) => this.dispatch(names.SET_NAME, name);
    setParentDivision = (divisionId: number) => this.dispatch(names.SET_PARENT_DIVISION, divisionId);
    setDivisionItems = (divisions: Division[]) => this.dispatch(names.SET_DIVISION_ITEMS, divisions);
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Division/EditCreateDivisionActions.ts